import { csx } from '@vtex/admin-ui'

const styles = {
  icon: csx({
    justifyContent: 'center',
    display: 'flex',
    gridColumn: 'icon',
    color: '$secondary',
  }),

  description: csx({ paddingBottom: '$space-2', gridColumn: 'title' }),

  stack: csx({
    width: 'full',
    ':has(.rule-item)': {
      border: '$neutral',
    },
    ':empty': {
      display: 'none',
    },
    borderRadius: 8,
    '> :not(.rule-item:last-of-type)': {
      borderBottom: '$neutral',
    },
    '.rule-item': {
      position: 'relative',
      ':not(:first-of-type):not([data--condition-connector=""])::before': {
        content: 'attr(data--condition-connector)',
        position: 'absolute',
        top: 0,
        left: 0,
        marginTop: '-0.8rem',
        color: '$secondary',
        background: '$primary',
        border: '$neutral',
        borderRadius: 90,
        minHeight: '1.5rem',
        minWidth: '1.5rem',
        marginLeft: '$space-5',
        paddingX: '$space-2',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: 'normal',
        zIndex: 2,
      },
      '& .rule-item': {
        padding: '$space-4',
        ':not(:last-of-type)': {
          paddingBottom: '$space-6',
        },
      },
    },
  }),

  rule: csx({
    position: 'relative',
    padding: '$space-6',
    columnGap: '$space-4',
    ':first-child': {
      borderTopRightRadius: 8,
      borderTopLeftRadius: 8,
    },
    ':last-child': {
      borderBottomRightRadius: 8,
      borderBottomLeftRadius: 8,
    },
    ':hover': {
      '.actions': {
        opacity: 1,
      },
    },
    ':not(:first-of-type):not([data--condition-connector=""])': {
      paddingTop: '$space-7',
    },
    '[data-clickable="true"]': {
      cursor: 'pointer',
      ':hover:not(:has([data-stop-propagation]:hover))': {
        '::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: '$form.control',
          pointerEvents: 'none',
        },
      },
      ':first-child:hover::after': {
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
      },
      ':last-child:hover::after': {
        borderBottomLeftRadius: 7,
        borderBottomRightRadius: 7,
      },
    },
  }),

  title: csx({ minWidth: '1/3' }),

  actions: csx({
    gridColumn: 'actions',
    ':has(button[data-open="false"])': {
      opacity: 0,
      transition: 'opacity 0.1s',
    },
  }),

  content: csx({
    gridColumn: 'rules',
    '[data-fluid]': {
      gridColumn: '1 / -1',
    },

    '.rule-item': {
      display: 'flex',
      flexDirection: 'column',
      background: '#FAFAFA',
      '& [data-pp-tag]': {
        background: '#EFEFEF',
      },
      ':first-child': {
        borderTopRightRadius: 8,
        borderTopLeftRadius: 8,
      },
      ':last-child': {
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8,
      },
    },
  }),
}

export default styles
